import type { BoardPoint, TimedGameSnapshot } from '@wx-weiqi/contracts';

export interface MoveDraft {
  readonly gameId: string;
  readonly stateVersion: number;
  readonly point: BoardPoint;
}

export function unfinishedGame(snapshot: TimedGameSnapshot): boolean {
  return snapshot.status !== 'FINISHED' && snapshot.status !== 'ABORTED';
}

export function currentMoveDraft(
  draft: MoveDraft | null,
  snapshot: TimedGameSnapshot,
  canPlay: boolean,
): BoardPoint | null {
  return canPlay &&
    draft?.gameId === snapshot.gameId &&
    draft.stateVersion === snapshot.stateVersion
    ? draft.point
    : null;
}

export function boardPointLabel(point: BoardPoint, size: number): string {
  return `${'ABCDEFGHJKLMNOPQRSTUVWXYZ'[point.x]}${size - point.y}`;
}

/** Spatial navigation only; never determines move legality. */
export function nextBoardFocus(index: number, size: number, key: string): number {
  const x = index % size;
  const y = Math.floor(index / size);
  switch (key) {
    case 'ArrowLeft':
      return y * size + Math.max(0, x - 1);
    case 'ArrowRight':
      return y * size + Math.min(size - 1, x + 1);
    case 'ArrowUp':
      return Math.max(0, y - 1) * size + x;
    case 'ArrowDown':
      return Math.min(size - 1, y + 1) * size + x;
    case 'Home':
      return y * size;
    case 'End':
      return y * size + size - 1;
    default:
      return index;
  }
}
